const processLocalize = {
  "process successfully updated": "Processo atualizado com sucesso",
  "process successfully deleted": "Processo deletado com sucesso",
  "already exists a process with this description": "Já existe um processo com essa descrição"
};

export default processLocalize;